<template>
  <g-signin-button
    :params="googleSignInParams"
    @success="onGoogleSignInSuccess"
    @error="onGoogleSignInError"
  >
    <v-btn color="#C94030" outlined rounded>Login/Register with Google</v-btn>
  </g-signin-button>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import GSignInButton from "vue-google-signin-button";
Vue.use(GSignInButton);

export default {
  data() {
    return {
      googleSignInParams: {
        client_id: process.env.VUE_APP_GOOGLE_SIGN_CLIENT_ID,
      },
    };
  },
  methods: {
    ...mapActions({
      googleLogin: "auth/googleLogin",
    }),
    onGoogleSignInSuccess(googleUser) {
      this.googleLogin({
        idToken: googleUser.getAuthResponse().id_token,
        redirectUrl: this.$route.query.redirectUrl,
      });
    },
    onGoogleSignInError() {},
  },
};
</script>